document.addEventListener('turbo:load', function() {
  if (!document.getElementById('reporting-index')) {
    return;
  }

  // Only the params being changed are rebuilt, so everything else already on
  // the URL. this tab and the other tab's filters are left as is.
  const visit = (keys, params) => {
    const search = new URLSearchParams(window.location.search);
    keys.forEach(key => search.delete(key));
    Object.entries(params).forEach(([key, value]) => search.set(key, value));

    Turbo.visit(`${window.location.origin}${window.location.pathname}?${search.toString()}`, { action: 'replace' });
  };

  const dateFilter = document.getElementById('reporting-date-filter');
  if (dateFilter) {
    const period = document.getElementById('reporting_period');
    const from = document.getElementById('reporting_from');
    const to = document.getElementById('reporting_to');
    const apply = document.getElementById('reporting_apply');
    const visitDates = (params) => visit(['period', 'from', 'to'], params);

    period.addEventListener('change', function(e) {
      // Custom waits for both dates and an explicit Apply, otherwise picking it
      // would navigate straight back to whatever range was already loaded.
      if (e.target.value === 'custom') {
        return;
      }

      visitDates({ period: e.target.value });
    });

    apply.addEventListener('click', function() {
      if (!from.value || !to.value) {
        return;
      }

      visitDates({ period: 'custom', from: from.value, to: to.value });
    });
  }

  // The sales tab's filters. Both navigate as soon as they are picked, so the
  // common case is a single click.
  const year = document.getElementById('reporting_year');
  if (year) {
    year.addEventListener('change', e => visit(['year'], { year: e.target.value }));
  }

  const user = document.getElementById('reporting_user');
  if (user) {
    // "All users" is the absence of the param rather than a value for it.
    user.addEventListener('change', e => visit(['user_id'], e.target.value ? { user_id: e.target.value } : {}));
  }
});
